module.exports = __webpack_public_path__ + "img/title-font.ebd7ac4f.png";